import { PaginatorState } from './crud-table/models/paginator.model';
import { BehaviorSubject } from 'rxjs';
import { TableResponseModel } from './crud-table/models/table.model';
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable({
	providedIn: "root"
})

export class RatingService<T> extends BaseService<T> {

	constructor(
		@Inject(HttpClient) http
	) {
		super(http);
	}

	get _tableState() {
		return this.tableState;
	};

	private _ratings$: BehaviorSubject<T[]> = new BehaviorSubject([]);

	get ratings$() {
		return this._ratings$.asObservable();
	}

	private _total$: BehaviorSubject<number> = new BehaviorSubject(0);

    get total$() {
        return this._total$.asObservable();
    }

	rateSupplier(payloadData) {
		const apiUrl = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.RATING.RATE;
		return this.post(apiUrl, payloadData);
	}

	/**
	 * return className of rated value
	 */
	getRateClass(value) {
		value = parseFloat(value);
		if(value >= 0.5 && value <= 2){
			return 'bad';
		} else if(value > 2 && value <= 4){
			return 'normal';
		} else if(value > 4 && value <= 5){
			return 'good';
		}
	}

	/**
	 * Get all rating details for supplier
	 */
	getSupplierRatings(tableState) {
		const apiUrl = this.API_URL + this.VERSION_V1 + this.API_ROUTES.SUPPLIER.RATING.SEARCH;
		this.post(apiUrl, tableState).subscribe((res: TableResponseModel<T>) => {
			this._ratings$.next(res.items);
			this._total$.next(res.total);
		});
	}
}
